import { ArrowLeftRight } from "lucide-react";

import { ColocaAlert } from "@/shared/components/feedback/ColocaAlert";
import useTranslations from "@/shared/lang/useTranslations";

export interface CrossCurrencyNoticeProps {
  sourceCurrency: string;
  deliveryCurrency: string;
}

/** Shown when the wallet's currency differs from the corridor's: the conversion happens inside each payment. */
export function CrossCurrencyNotice({ sourceCurrency, deliveryCurrency }: CrossCurrencyNoticeProps) {
  const { t } = useTranslations("payoutBatches");
  return (
    <ColocaAlert
      variant="secondary"
      icon={ArrowLeftRight}
      heading={t("setup_cross_currency_title")}
      text={t("setup_cross_currency_text", {
        source: sourceCurrency,
        currency: deliveryCurrency,
      })}
    />
  );
}
